import React, { useEffect, useMemo, useState } from 'react'
import AAutoComplete from '../../../../common/form-fields-mui/AAutoComplete';
import styles from "./styles.module.scss";
import { useGetAllBusinessArea } from './utils';
import { Dialog } from '@mui/material';
import { failureToast, successToast } from '../../../../common/utils/methods/toasterFunctions/function';
import { ReactComponent as CrossIcon } from "../../../../../../../assets/img/svg/CrossIcon.svg"
import AInput from '../../../../common/formFeilds/customInput/AInput';
import AButton from '../../../../common/form-fields-mui/AButton';
import ADataGrid from '../../../../common/data-grid/ADataGrid';
import NoRowOverlay from '../../../../masters/holidayMaster/NoRowOverlay';
import { gridComponents, gridStyles } from '../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import { AGridColDef } from '../../../../common/data-grid/ADataGridColDef';
import { StatusChip } from './utils';
import CustomLoader from '../../../../common/commonComponents/Loader/loader';
import { fetchAllPostPromisedData } from '../../../../common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from '../../../../common/constant';


const CopyFeaturesToBuDropdown = ({ form, setForm, buId, fetchFeatureSetupData }) => {

    const [sourceBuFeatures, setSourceBuFeatures] = useState({ fetching: false, data: [] , currentPage: 0, totalRecords: 0});

    const allActiveBu = useGetAllBusinessArea(true, (bu) => `${bu?.businessAreaDispValue} | ${bu?.businessAreaDesc}`);

    const copyBuDropdownData = useMemo(() => {
        return allActiveBu?.filter(bu => bu?.id != buId);
    },[allActiveBu, buId]);

    const { sourceBu, currentBu } = form ?? {};

    const columns = [
        new AGridColDef('feature', 'Feature', false)
            .setMinWidth(110)
            .setFlex(0.5)
            .editable(true)
            .setValueGetter(params => params?.value),

        new AGridColDef('status', 'Status', false)
            .setMinWidth(110)
            .setFlex(0.5)
            .editable(true)
            .renderCellComponent(params => <StatusChip val={params?.value} />),
    ]

    const copyBuChangeHandler = (val) => {
        if (!!form) {
            failureToast("Please save or discard current changes!");
            return;
        }


        setForm({
            sourceBu: val,
            currentBu: allActiveBu?.find(bu => bu?.id == buId),
            ticketNo: '',
            isCopyBuDialogOpen: true
        })

        fetchFeatureSetupData(0, setSourceBuFeatures, val?.id);
    }

    const copyBuFeatures = async () => {
        try {
            const reqObj = {
                ticketNumber: form?.ticketNo?.trim(),
                businessArea: form?.currentBu?.id
            }

            const resp = await fetchAllPostPromisedData(`${endpoint.featureSetup.copyFeatureSetup}/${form?.sourceBu?.id}`, reqObj);
            if (resp?.code === 200) {
                successToast("Request completed successfully");
                setForm(null);
                fetchFeatureSetupData();
            }

        } catch (err) {
            console.error(err);
        }
    }

    const pageChangeHandler = (newPage) => {
        fetchFeatureSetupData(newPage, setSourceBuFeatures , form?.sourceBu?.id);
    }


    return (

        <>
            <AAutoComplete
                items={copyBuDropdownData}
                currentValue={form?.sourceBu ?? ''}
                placeholder="Select branch to copy settings"
                handleChange={(val) => copyBuChangeHandler(val)}
                isMulti={false}
            />

            <Dialog
                open={form?.isCopyBuDialogOpen}
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "400px",
                        },
                    },
                }}
            >
                <div className='m-2 p-2'>
                    <span className={styles['ticket-form-dialog-header']}>Features of {sourceBu?.businessAreaDispValue}</span>
                    <CrossIcon onClick={() => setForm(null)} className='ml-4 float-right cursor' />

                    <div className={`mt-1 mb-2 ${styles['copyBuForm-sub-header']}`}>{sourceBu?.businessAreaDispValue + " " + sourceBu?.businessAreaDesc} → {currentBu?.businessAreaDispValue + " " + currentBu?.businessAreaDesc}</div>

                    {sourceBuFeatures?.fetching
                        ? <CustomLoader />
                        :
                        <>

                            <ADataGrid
                                removeWrapperContainer
                                rows={sourceBuFeatures?.data || []}
                                columns={columns}
                                rowId={(row) => row.id}
                                rowHeight={50}
                                loading={false}
                                pageSize={10}
                                rowCount={sourceBuFeatures?.totalRecords}
                                nextButtonHandler={pageChangeHandler}
                                currentPage={sourceBuFeatures?.currentPage}
                                components={{
                                    ...gridComponents,
                                    NoRowsOverlay: () => (
                                        <NoRowOverlay />
                                    ),
                                }}
                                sx={gridStyles}
                                autoHeight
                            // pinLastColumn
                            />

                            <AInput
                                label="Ticket number"
                                labelStyle={{ fontWeight: 600, fontSize: '12px' }}
                                style={{ height: '42px' }}
                                placeholder="Enter ticket no"
                                value={form?.ticketNo}
                                handler={(val) => setForm(prev => ({ ...prev, ticketNo: val }))}
                            />

                            <AButton
                                variant="primary_filled"
                                className='no-ml-btn mt-2'
                                disabled={!form?.ticketNo?.trim()}
                                onClick={copyBuFeatures}
                            >
                                Copy features to {currentBu?.businessAreaDispValue}
                            </AButton>
                        </>
                    }

                </div>
            </Dialog>
        </>

    );
}

export default CopyFeaturesToBuDropdown;